/* aw-maattabel.js — het openen en sluiten van het maattabelvenster.
 *
 * Het PLAATSEN van de knop gebeurt NIET hier maar in aw-variant.js. Dat is geen
 * willekeur: dat script heeft al een waarnemer op de variantkiezer, met de
 * losmaak-tijdens-schrijven-regel erin. Een tweede waarnemer op hetzelfde stuk
 * pagina laat de twee elkaar aan het werk zetten, en dan laadt de pagina nooit
 * klaar. Eén waarnemer per stuk pagina.
 *
 * Hier staat alleen wat op een KLIK gebeurt. Dat mag met overdracht op document,
 * want dan overleeft het elke hertekening van Horizon vanzelf.
 *
 * De beweging is overgenomen van de bron, gemeten in zijn eigen code:
 *   vanaf 700px  het hele venster van 0 naar 1 in 0,2s
 *   daaronder    de waas van 0 naar 1 en het blad van translateY(100%) naar 0,
 *                allebei 0,3s met cubic-bezier(.645,.045,.355,1), tegelijk
 */
(() => {
  /* Het blok laadt dit bestand met een eigen `<script>`. Hertekent Horizon de
     sectie, dan voert de browser dat script opnieuw uit en zouden alle
     luisteraars er dubbel op staan. Vandaar deze klink. */
  if (window.__awMaattabel) return;
  window.__awMaattabel = true;

  const BREED = window.matchMedia('(min-width: 700px)');
  let vorigeKnop = null;
  /* Werd de maattabel met een TIK/KLIK geopend, of met het toetsenbord? Dat
     bepaalt of de focus bij het sluiten terug mag naar de knop. Zie `dicht()`. */
  let metToetsenbord = false;

  const venster = () => document.getElementById('aw-sgc-venster');

  /* Horizon schuift op het bureaublad niet in het venster maar in .page-wrapper.
     Alleen `html` op slot zetten houdt de pagina daar dus niet stil. */
  function slot(aan) {
    const doelen = [document.documentElement, document.querySelector('.page-wrapper')];
    doelen.forEach((el) => { if (el) el.style.overflow = aan ? 'hidden' : ''; });
  }

  function open(knop, viaToetsenbord) {
    const v = venster();
    if (!v || v.hasAttribute('open')) return;
    vorigeKnop = knop || null;
    metToetsenbord = !!viaToetsenbord;
    v.hidden = false;
    /* Zonder deze uitlezing zet de browser `hidden` weg en `open` erbij in
       dezelfde stap, en dan is er geen begintoestand om vanaf te bewegen. */
    void v.offsetWidth;
    v.setAttribute('open', '');
    slot(true);
    if (knop) knop.setAttribute('aria-expanded', 'true');
    /* De aandacht gaat naar het VAK en niet naar de sluitknop. Dat is geen
       smaak: op de sluitknop tekent de browser zijn eigen ring, en dan staat er
       een vierkantje om het kruisje dat de bron niet heeft. Het vak heeft
       `tabindex="-1"`, dus het is alleen met code te bereiken en de ring valt
       weg zonder dat er iets onbereikbaar wordt. */
    const vak = v.querySelector('.aw-sgc-venster__vak');
    if (vak) vak.focus({ preventScroll: true });
  }

  function dicht() {
    const v = venster();
    if (!v || !v.hasAttribute('open')) return;
    v.removeAttribute('open');
    slot(false);
    document.querySelectorAll('.aw-sgc-link[aria-expanded="true"]')
      .forEach((k) => k.setAttribute('aria-expanded', 'false'));

    /* Wachten tot de beweging klaar is, anders knippert het blad weg in plaats
       van omlaag te schuiven. De klok is de terugval voor het geval de
       overgang niet vuurt (verminderde beweging, of een verborgen tabblad). */
    const klaar = () => { if (!v.hasAttribute('open')) v.hidden = true; };
    const beweger = BREED.matches ? v : v.querySelector('.aw-sgc-venster__vak');
    let gedaan = false;
    const eenmaal = () => { if (gedaan) return; gedaan = true; klaar(); };
    if (beweger) beweger.addEventListener('transitionend', eenmaal, { once: true });
    setTimeout(eenmaal, 420);

    /* De focus gaat ALLEEN terug naar de knop als de maattabel met het
       toetsenbord is geopend.

       Waarom: bij een tik zet de teruggegeven focus de browser aan het werk en
       tekent die zijn eigen ring om de knop -- een vierkantje dat er bij de bron
       niet staat. Precies dezelfde val als bij de sluitknop, zie de aantekening
       in `open()`. Gemeten na een echte tik op het kruisje: de focus komt terug
       op de knop (`:focus = true`), en Horizon zet die standaardring nergens uit
       (het andere thema doet dat wel, met `:focus:not(:focus-visible){outline:none}`).

       Wegnemen met CSS lukte niet betrouwbaar: op de telefoon van de eigenaar
       bleef het vierkantje staan, en headless WebKit tekent die ring hier
       helemaal niet, dus het is van hieruit niet te toetsen. Daarom is nu de
       OORZAAK weg: geen focus, dan valt er ook niets te tekenen.

       Voor wie met een toetsenbord navigeert verandert er niets: daar komt de
       focus wel terug, want anders val je terug naar het begin van de pagina. */
    if (metToetsenbord && vorigeKnop && document.contains(vorigeKnop)) {
      vorigeKnop.focus({ preventScroll: true });
    }
    vorigeKnop = null;
    metToetsenbord = false;
  }

  document.addEventListener('click', (e) => {
    const knop = e.target.closest('.aw-sgc-link');
    /* `e.detail` is 0 bij een klik die van het TOETSENBORD komt (Enter of
       spatie op een knop) en groter dan 0 bij een echte tik of muisklik. Dat is
       de standaardmanier om die twee uit elkaar te houden. */
    if (knop) { e.preventDefault(); open(knop, e.detail === 0); return; }
    if (e.target.closest('[data-aw-sgc-sluit]')) { e.preventDefault(); dicht(); }
  });

  /* In de thema-editor hoort een blok open te gaan zodra je het in de zijbalk
     aanklikt, anders lijkt het blok niets te doen. De bron doet precies dit:
     zijn dialoogelement luistert in `Shopify.designMode` op `block:select` en
     `block:deselect`. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      if (e.target && e.target.id === 'aw-sgc-venster') open(null);
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      if (e.target && e.target.id === 'aw-sgc-venster') dicht();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const v = venster();
    if (v && v.hasAttribute('open')) dicht();
  });

  /* De klemring. Geen bibliotheek: het venster heeft precies twee soorten
     bedienbare dingen (de sluitknop en het eenheidsknopje), dus de lijst is
     kort en het opnieuw uitlezen kost niets. */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const v = venster();
    if (!v || !v.hasAttribute('open')) return;
    const kan = [...v.querySelectorAll('button, [href], input:not([hidden]), label[tabindex], [tabindex]:not([tabindex="-1"])')]
      .filter((el) => el.offsetParent !== null || el === document.activeElement);
    if (!kan.length) return;
    const eerste = kan[0], laatste = kan[kan.length - 1];
    if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
    else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
  });
})();
